export const ALERT_CLOSE_ANIMATION_DURATION_MS = 300;

export const TOAST_MAX_VISIBLE = 3;
export const TOAST_STACK_HOVER_MIN_COUNT = 2;
export const TOAST_EXPANDED_WIDTH = 420;
export const TOAST_COLLAPSED_HEIGHT = 82;
export const TOAST_EXPANDED_GAP = 10;
export const TOAST_COLLAPSED_WIDTHS = [TOAST_EXPANDED_WIDTH, 400, 382];
export const TOAST_COLLAPSED_X_OFFSETS = [0, 10, 19];
export const TOAST_COLLAPSED_Y_OFFSETS = [0, 14, 26];
